import React, { createContext, useRef } from 'react'
import { Toast } from 'primereact/toast'

export const ToastContext = createContext<React.RefObject<Toast | null> | null>(null)

export const ToastProvider: React.FunctionComponent = (props) => {
  const toast = useRef<Toast>(null)

  return (
    <ToastContext.Provider value={toast}>
      <Toast ref={toast} />
      {props.children}
    </ToastContext.Provider>
  )
}
